import React, { useState, useEffect } from "react";
import "../../Styles/Pages/Admin/Farmers.css";
import Admin_topbar from "../../Layouts/Admin_layout/Admin_topbar";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Button,
  Pagination,
  Grid,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Autocomplete,
} from "@mui/material";
import "../../Styles/Pages/admin_fieldofficers.css";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import CloseIcon from "@mui/icons-material/Close";
import { instance } from "../../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import { NavLink } from "react-router-dom";
import { FiEye } from "react-icons/fi";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
  border: "1px solid #79c245",
  marginRight: "10px",
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#79c245",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  fontFamily: "Poppins,sans-serif",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

function Farmers() {
  const [farmers, setFarmers] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredFarmers, setFilteredFarmers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [farmerpage] = useState(10);
  const indexOfLastfarmer = currentPage * farmerpage;
  const indexOfFirstfarmer = indexOfLastfarmer - farmerpage;
  const currentfarmer = filteredFarmers.slice(
    indexOfFirstfarmer,
    indexOfLastfarmer
  );

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase().trim();
    setSearch(query);

    if (!query) {
      setFilteredFarmers(farmers);
    } else {
      const filtered = farmers.filter((farmer) =>
        Object.values(farmer).some((value) =>
          value !== null && value !== undefined && value.toString().toLowerCase().includes(query)
        )
      );
      setFilteredFarmers(filtered);
    }

    setCurrentPage(1);
  };


  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const fetchFarmers = async () => {
    try {
      const response = await instance.get("/getFarmers");
      const sortedfarmers = response.data.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      )
      setFarmers(sortedfarmers);
      setFilteredFarmers(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchFarmers();
  }, []);

  return (
    <div style={{ margin: "20px 20px 0px 0px" }}>
      <Admin_topbar />
      <div className="officer_section">
        <section className="main_box">
          <div className="container-fluid">
            <div className="table_box">
              <TableContainer component={Paper}>
                <div className="table_inbox">
                  <div className="add_user_list">
                    <div className="add_user_content">
                      <div
                        style={{
                          fontFamily: "Poppins,sans-serif",
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                      >
                        Farmers
                      </div>
                    </div>
                    <div className="add_user">
                      <div>
                        <Search>
                          <SearchIconWrapper>
                            <SearchIcon />
                          </SearchIconWrapper>
                          <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ "aria-label": "search" }}
                            type="search"
                            value={search}
                            onChange={handleSearch}
                          />
                        </Search>
                      </div>
                    </div>
                  </div>
                  <div className="adduser_table">
                    <Table
                      className="user_table product_table"
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow className="table_head">
                          <TableCell align="center" className="first-child">
                            Sl.No
                          </TableCell>
                          <TableCell align="center" className="second-child">
                            Farmer Name
                          </TableCell>
                          {/* <TableCell align="center" className="second-child">
                            Date Of Birth
                          </TableCell>
                          <TableCell align="center" className="third-child">
                            Email
                          </TableCell> */}
                          <TableCell align="center" className="third-child">
                            Mobile
                          </TableCell>
                          <TableCell align="center" className="third-child">
                            Aadhaar Number
                          </TableCell>
                          <TableCell align="center" className="third-child">
                            Village
                          </TableCell>
                          <TableCell align="center" className="third-child">
                            District
                          </TableCell>
                          <TableCell align="center" className="third-child">
                            State
                          </TableCell>
                          <TableCell align="center" className="third-child">
                            Category
                          </TableCell>
                          <TableCell align="center" className="second-child">
                            Vendor Name
                          </TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="table_body">
                        {currentfarmer.length > 0 ? (
                          currentfarmer.map((farmer, index) => (
                            <TableRow key={farmer._id}>
                              <TableCell align="center">
                                {index + 1 + (currentPage - 1) * farmerpage}
                              </TableCell>
                              <TableCell align="center">
                                {farmer.name}
                              </TableCell>
                              {/* <TableCell align="center">
                                {farmer?.dob}
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.email}
                              </TableCell> */}
                              <TableCell align="center">
                                {farmer.mobile_no}
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.aadhaar_number}
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.village}
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.district}
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.state}
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.category}
                              </TableCell>
                              <TableCell align="center">
                                {farmer?.vendor?.name}
                              </TableCell>
                              <TableCell align="center">
                                <NavLink
                                  to={`/admin/Fields/${farmer.hash}`}
                                  className="farmer-details"
                                >
                                  <FiEye />
                                </NavLink>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableCell colSpan={12} align="center">
                            <Typography>No matched items</Typography>
                          </TableCell>
                        )}
                      </TableBody>
                    </Table>
                  </div>
                  <div className="pagination_table">
                    <Pagination
                      count={Math.ceil(filteredFarmers.length / farmerpage)}
                      page={currentPage}
                      onChange={(event, page) => paginate(page)}
                      shape="rounded"
                      variant="outlined"
                    />
                  </div>
                </div>
              </TableContainer>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Farmers;
